export { default } from 'common/enums/product-type.enum';
